import { PromptTemplateCategory } from '../types';

export const dialogue: PromptTemplateCategory = {
  title: "Đối thoại",
  icon: "💬",
  templates: [
    {
      title: "Mẫu Phỏng vấn Podcast",
      content: `Viết một cuộc phỏng vấn kiểu podcast giữa hai người nói.
- Người nói 1 là người dẫn chương trình: [một nhà báo công nghệ tò mò và nhiệt tình].
- Người nói 2 là khách mời: [một nhà nghiên cứu AI nổi tiếng vừa công bố một bài báo đột phá].
- Chủ đề thảo luận là [tương lai của sự hợp tác giữa con người và AI trong các lĩnh vực sáng tạo].
- Giọng điệu nên [mang tính đối thoại, sâu sắc và đôi khi hài hước].
- Bao gồm trao đổi tự nhiên với các câu hỏi tiếp theo và giai thoại.

Định dạng mỗi dòng là "Speaker 1:" hoặc "Speaker 2:" theo sau là lời thoại của họ.`,
      mode: 'multi'
    },
    {
      title: "Mẫu Tranh luận",
      content: `Viết một cuộc tranh luận có cấu trúc giữa hai người nói với quan điểm đối lập.
- Người nói 1 lập luận [ủng hộ việc làm việc từ xa trở thành mặc định vĩnh viễn].
- Người nói 2 lập luận [rằng sự hợp tác tại văn phòng là cần thiết cho đổi mới].
- Cả hai người nói nên trình bày [các lập luận hợp lý với ví dụ thực tế].
- Giọng điệu nên [tôn trọng nhưng đầy nhiệt huyết].
- Mỗi người nói nên phản hồi trực tiếp các điểm của đối phương.

Định dạng mỗi dòng là "Speaker 1:" hoặc "Speaker 2:" theo sau là lời thoại của họ.`,
      mode: 'multi'
    },
    {
      title: "Mẫu Đối thoại Học ngôn ngữ",
      content: `Viết một đoạn đối thoại giao tiếp giữa hai người nói dành cho người học ngôn ngữ.
- Kịch bản là [gọi món ăn tại một chợ đường phố nhộn nhịp].
- Người nói 1 là [một người bán hàng địa phương thân thiện giới thiệu các món ăn ngon nhất].
- Người nói 2 là [một du khách lần đầu thử ẩm thực địa phương].
- Bao gồm [sự do dự tự nhiên, cụm từ lịch sự và bối cảnh văn hóa].
- Đoạn đối thoại nên chân thực và giúp người học nắm được [các cụm từ giao tiếp hàng ngày].

Định dạng mỗi dòng là "Speaker 1:" hoặc "Speaker 2:" theo sau là lời thoại của họ.`,
      mode: 'multi'
    }
  ]
};
